module.exports = __webpack_public_path__ + "img/16581248_L.cc2775fc.png";